import $ from 'jquery';

export default class Navigation {
  constructor(options) {
    this.$el = $(options.el);
    this.megaNav = $('.mega-nav', this.$el);
    this.secondaryTier = this.megaNav.find('.secondary');

    this._bindEvents();
  }

  _bindEvents() {
    $('.header-drawer .has-dropdown > a .dropdown-toggle', this.$el).on('click', (e) => this.toggleNavigation(e));

    $(document.body).on('click', (e) => {
      if (!$(e.target).closest('.navigation').length) {
        $('.navigation .open', this.$el).removeClass('open');
        if (this.megaNav.length) { return this.resetMegaNav(); }
      }
    });
  }

  toggleNavigation(e) {
    e.preventDefault();

    let target = $(e.currentTarget);
    let button = $(e.currentTarget).children('.dropdown-toggle');

    if (target.hasClass('dropdown-toggle')) {
      button = target;
      target = target.parent();
    }

    const megaNavHeight = this.megaNav.outerHeight();

    if (target.parent().hasClass('has-dropdown')) {
      e.preventDefault();

      if (target.hasClass('main-nav-item') && target.parent().hasClass('has-mega-nav')) {
        if (target.parent().hasClass('open')) {
          this.resetMegaNav();
          $('.navigation li', this.$el).removeClass('open');
        } else {
          $('.navigation li', this.$el).removeClass('open');
          target.parent().addClass('open');
        }
      } else if (target.hasClass('main-nav-item') && target.parent().hasClass('simple-dropdown')) {
        if (target.parent().hasClass('open')) {
          $('.navigation li', this.$el).removeClass('open');
        } else {
          this.resetMegaNav();
          $('.navigation li', this.$el).removeClass('open');
          target.parent().addClass('open');
        }
      } else {
        target.parent().toggleClass('open');
      }

      button.attr('aria-expanded', target.parent().hasClass('open'));
    }
  }

  resetMegaNav() {
    setTimeout(() => {
      this.megaNav.height('auto');
      this.secondaryTier.removeClass('hide');
    },
    200);
  }
}
